"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "History",
    transform: "translate(3.000000, 2.000000)",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: "2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      id: "Rectangle",
      x: "0",
      y: "0",
      width: "13.3333333",
      height: "20",
      rx: "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.3333333,2.22222222 L15.7777778,2.22222222 C16.8823473,2.22222222 17.7777778,3.11765272 17.7777778,4.22222222 L17.7777778,15.7777778 C17.7777778,16.8823473 16.8823473,17.7777778 15.7777778,17.7777778 L13.3333333,17.7777778",
      id: "Rectangle-Copy"
    })]
  })
}));